/** Where the web tells people to get the app. TestFlight while in beta; swap for the App Store URL at launch. */
export const IOS_BETA_URL = 'https://testflight.apple.com/join/KYTmrrC3';
